import { Component, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { DocumentService } from '../../../services/document.service';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'video-player',
  templateUrl: 'video-player.html',
  styleUrls: ['video-player.scss']
})
export class VideoPlayerComponent implements OnDestroy{
  public endpoint;
  public type;
  public orientation;
  public videoError = false;
  public isLoading = false;
  public localVideoPath: string = null;
  
  @ViewChild('videoElement', { static: false }) videoElement: ElementRef;

  constructor(
    public router: Router, 
    public modalCtrl: ModalController, 
    private navParams: NavParams,
    private documentService: DocumentService,
    private platform: Platform
  ) {
    const idVideo = this.navParams.get('idVideo');
    this.orientation = this.navParams.get('orientation');
    this.type = this.navParams.get('type');
    this.endpoint = this.getEndpoint(this.type, idVideo);
    
    console.log('VideoPlayerComponent - idVideo:', idVideo);
    console.log('VideoPlayerComponent - type:', this.type);
    console.log('VideoPlayerComponent - endpoint:', this.endpoint);
    
    // Si es un video nativo en Android, descargarlo primero
    if ((this.type === 'native' || this.type === 'streaming') && this.platform.is('android')) {
      this.downloadAndPlayVideo(idVideo);
    }
  }

  private getEndpoint(type: 'youtube' | 'vimeo' | 'native' | 'streaming', idVideo) {
    console.log('getEndpoint - type:', type, 'idVideo:', idVideo);
    if (type === 'vimeo') return `https://player.vimeo.com/video/${idVideo}?autoplay=1`;
    if (type === 'youtube') return `https://www.youtube.com/embed/${idVideo}?autoplay=1`;
    
    // Para videos nativos, asegurarse de que la URL sea válida
    if (type === 'native' || type === 'streaming') {
      console.log('Video URL:', idVideo);
      // Verificar si la URL es válida
      try {
        new URL(idVideo);
        console.log('URL válida');
        
        // Para URLs de S3, asegurarse de que tengan los headers correctos
        if (idVideo.includes('s3.amazonaws.com')) {
          console.log('URL de S3 detectada');
          // En Android, las URLs de S3 pueden tener problemas de CORS
          // Vamos a intentar usar la URL tal como está
        }
      } catch (e) {
        console.error('URL inválida:', e);
      }
    }
    
    return idVideo;
  }

  public async closeAlertCancel() {
    this.endpoint = '';
    this.modalCtrl.dismiss('canceled');
  }

  ngAfterViewInit() {
    // Solo configurar los event listeners si no estamos descargando el video
    if (!this.isLoading && this.videoElement && this.videoElement.nativeElement) {
      this.setupVideoEventListeners();
    }
  }

  private setupVideoEventListeners() {
    if (this.videoElement && this.videoElement.nativeElement) {
      const video = this.videoElement.nativeElement;
      
      video.addEventListener('loadstart', () => {
        console.log('Video loadstart event');
      });
      
      video.addEventListener('loadedmetadata', () => {
        console.log('Video loadedmetadata event');
      });
      
      video.addEventListener('canplay', () => {
        console.log('Video canplay event');
      });
      
      video.addEventListener('error', (e) => {
        console.error('Video error event:', e);
        console.error('Video error details:', video.error);
        this.videoError = true;
      });
      
      video.addEventListener('load', () => {
        console.log('Video load event');
      });
      
      // Timeout para detectar si el video no se carga después de 10 segundos
      setTimeout(() => {
        if (video.readyState === 0) {
          console.error('Video no se pudo cargar después de 10 segundos');
          this.videoError = true;
        }
      }, 10000);
    }
  }

  async downloadAndPlayVideo(videoUrl: string) {
    this.isLoading = true;
    this.videoError = false;
    
    try {
      console.log('Descargando video para reproducción local...');
      
      // Generar un nombre de archivo único
      const fileName = `video_${Date.now()}.mp4`;
      
      const options = {
        url: videoUrl,
        path: fileName,
        directory: Directory.Data
      };
      
      const downloadedFile = await Filesystem.downloadFile(options);
      console.log('Video descargado:', downloadedFile.path);
      
      // Convertir la ruta del archivo a una URL que el video element pueda usar
      this.localVideoPath = downloadedFile.path;
      this.endpoint = Capacitor.convertFileSrc(downloadedFile.path);
      
      console.log('Video listo para reproducir localmente:', this.localVideoPath);
      console.log('URL convertida para video element:', this.endpoint);
      
      // Configurar los event listeners después de que el video esté listo
      setTimeout(() => {
        this.setupVideoEventListeners();
      }, 100);
      
    } catch (error) {
      console.error('Error descargando video:', error);
      this.videoError = true;
    } finally {
      this.isLoading = false;
    }
  }

  async downloadVideo() {
    const idVideo = this.navParams.get('idVideo');
    const videoDoc = {
      url: idVideo,
      uri: idVideo,
      name: 'Video',
      extension: 'mp4'
    };
    
    try {
      await this.documentService.downloadDoc(videoDoc, true);
    } catch (error) {
      console.error('Error downloading video:', error);
    }
  }

  ngOnDestroy(): void {
    this.endpoint = '';
  }
}
